module.exports = __webpack_public_path__ + "static/media/Bill (1).e5153e6b.svg";